// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".live-markdown--1mSuP{margin-bottom:46px;position:relative}.live-markdown-preview--nr4Hf{border:1px solid #d9d9d9;padding:15px}.live-markdown-editor--27ePV{background:#1d1f21;color:white;font-size:16px;position:relative}.live-markdown-editor--27ePV>div{overflow-x:auto !important}.live-markdown-editor--27ePV>div>textarea,.live-markdown-editor--27ePV>div>pre{padding:15px !important}.live-markdown-editor-toggle--1mZg6{align-items:center;border-width:0 1px 1px 1px;border-color:#d9d9d9;border-style:solid;box-sizing:border-box;cursor:pointer;display:flex;height:30px;padding:0 10px;position:absolute;top:100%;transition:0.2s;right:0}.live-markdown-editor-toggle--1mZg6:hover{background:#efefef}\n", ""]);
// Exports
exports.locals = {
	"live-markdown": "live-markdown--1mSuP",
	"live-markdown-preview": "live-markdown-preview--nr4Hf",
	"live-markdown-editor": "live-markdown-editor--27ePV",
	"live-markdown-editor-toggle": "live-markdown-editor-toggle--1mZg6"
};
module.exports = exports;
